module.exports = __webpack_public_path__ + "assets/img/Ram-Group-Website.f51681f8.jpg";